import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

interface HintTooltipProps {
  text: string;
  children: React.ReactElement;
  side?: 'top' | 'right' | 'bottom' | 'left';
  className?: string;
}

// Dica ao passar o mouse, explicando o que o botão faz (pedido da Meta no App
// Review: "explicar o significado dos botões"). O wrapper <span> mantém a dica
// funcionando em botões desabilitados, que não disparam eventos de ponteiro.
const HintTooltip: React.FC<HintTooltipProps> = ({ text, children, side = 'top', className = 'inline-flex' }) => (
  <TooltipProvider delayDuration={200}>
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={className}>{children}</span>
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-xs text-center leading-snug">
        {text}
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);

export default HintTooltip;
